/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export enum GraphQLContentStatus {
  ARCHIVED = "ARCHIVED",
  CURRENT = "CURRENT",
  DELETED = "DELETED",
  DRAFT = "DRAFT",
}

export enum SitePermissionType {
  ANONYMOUS = "ANONYMOUS",
  APP = "APP",
  EXTERNAL = "EXTERNAL",
  INTERNAL = "INTERNAL",
  JSD = "JSD",
}

//==============================================================
// END Enums and Input Objects
//==============================================================

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: UnreadCommentQuery
// ====================================================

export interface UnreadCommentQuery_comments_nodes_location_FooterComment {
  type: string;
}

export interface UnreadCommentQuery_comments_nodes_location_InlineComment_inlineResolveProperties {
  resolved: boolean;
  resolvedByDangling: boolean;
}

export interface UnreadCommentQuery_comments_nodes_location_InlineComment {
  type: string;
  inlineMarkerRef: string | null;
  inlineResolveProperties: UnreadCommentQuery_comments_nodes_location_InlineComment_inlineResolveProperties | null;
}

export type UnreadCommentQuery_comments_nodes_location = UnreadCommentQuery_comments_nodes_location_FooterComment | UnreadCommentQuery_comments_nodes_location_InlineComment;

export interface UnreadCommentQuery_comments_nodes_author_Anonymous {
  permissionType: SitePermissionType | null;
}

export interface UnreadCommentQuery_comments_nodes_author_KnownUser {
  permissionType: SitePermissionType | null;
  accountId: string | null;
}

export interface UnreadCommentQuery_comments_nodes_author_User {
  permissionType: SitePermissionType | null;
  accountId: string | null;
}

export type UnreadCommentQuery_comments_nodes_author = UnreadCommentQuery_comments_nodes_author_Anonymous | UnreadCommentQuery_comments_nodes_author_KnownUser | UnreadCommentQuery_comments_nodes_author_User;

export interface UnreadCommentQuery_comments_nodes_createdAt {
  value: string;
}

export interface UnreadCommentQuery_comments_nodes_replies_author_Anonymous {
  permissionType: SitePermissionType | null;
}

export interface UnreadCommentQuery_comments_nodes_replies_author_KnownUser {
  permissionType: SitePermissionType | null;
  accountId: string | null;
}

export interface UnreadCommentQuery_comments_nodes_replies_author_User {
  permissionType: SitePermissionType | null;
  accountId: string | null;
}

export type UnreadCommentQuery_comments_nodes_replies_author = UnreadCommentQuery_comments_nodes_replies_author_Anonymous | UnreadCommentQuery_comments_nodes_replies_author_KnownUser | UnreadCommentQuery_comments_nodes_replies_author_User;

export interface UnreadCommentQuery_comments_nodes_replies_createdAt {
  value: string;
}

export interface UnreadCommentQuery_comments_nodes_replies_location_FooterComment {
  type: string;
}

export interface UnreadCommentQuery_comments_nodes_replies_location_InlineComment_inlineResolveProperties {
  resolved: boolean;
}

export interface UnreadCommentQuery_comments_nodes_replies_location_InlineComment {
  type: string;
  inlineMarkerRef: string | null;
  inlineResolveProperties: UnreadCommentQuery_comments_nodes_replies_location_InlineComment_inlineResolveProperties | null;
}

export type UnreadCommentQuery_comments_nodes_replies_location = UnreadCommentQuery_comments_nodes_replies_location_FooterComment | UnreadCommentQuery_comments_nodes_replies_location_InlineComment;

export interface UnreadCommentQuery_comments_nodes_replies {
  id: string;
  author: UnreadCommentQuery_comments_nodes_replies_author;
  createdAt: UnreadCommentQuery_comments_nodes_replies_createdAt;
  location: UnreadCommentQuery_comments_nodes_replies_location;
}

export interface UnreadCommentQuery_comments_nodes {
  id: string;
  location: UnreadCommentQuery_comments_nodes_location;
  author: UnreadCommentQuery_comments_nodes_author;
  createdAt: UnreadCommentQuery_comments_nodes_createdAt;
  replies: (UnreadCommentQuery_comments_nodes_replies | null)[];
}

export interface UnreadCommentQuery_comments {
  nodes: (UnreadCommentQuery_comments_nodes | null)[] | null;
}

export interface UnreadCommentQuery {
  comments: UnreadCommentQuery_comments | null;
}

export interface UnreadCommentQueryVariables {
  pageId: string;
  contentStatus?: (GraphQLContentStatus | null)[] | null;
}
